module.exports = __webpack_public_path__ + "img/loading_dog_02.29da1fe2.png";